import React, { useEffect, useMemo, useState } from "react";
import cx from "classnames";

import { Hooks, Util } from "@xt/xtbase";
const { useTranslation } = Hooks;
const { getUrl } = Util;

import styles from "./index.module.scss";

// interface Props extends React.HTMLAttributes<HTMLDivElement> {
//   label?: string;
// }

const AppDivToLogin: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, ...rest }) => {
  const t = useTranslation();

  const [urlObj, setUrlObj] = useState({ login: "", register: "" });
  useEffect(() => {
    const query = "?backurl=" + encodeURIComponent(location.href);
    setUrlObj({
      login: getUrl("/accounts/login" + query),
      register: getUrl("/accounts/register" + query),
    });
  }, []);

  const htmlStr = useMemo(() => {
    const arg0 = `<a style="color:#B9F78A" href="${urlObj.login}">${t("trade.loginLowerCase")}</a>`;
    const arg1 = `<a style="color:#B9F78A" href="${urlObj.register}">${t("trade.registerLowerCase")}</a>`;

    return t("trade.loginOrRegister", [arg0, arg1]);
  }, [urlObj]);

  return (
    <div className={cx(styles.main, className)} {...rest}>
      <span dangerouslySetInnerHTML={{ __html: htmlStr }}></span>
    </div>
  );
};

export default AppDivToLogin;
